import { useState } from 'react';
import Axios from '../utils/axiosInstance';

const useHomeData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getHomeData = async () => {
    setLoading(true);
    setError(null);

    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}collection/homepage/`;
      const response = await Axios.get(apiUrl);
      return response.data; // Return data
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { getHomeData, loading, error };
};

export default useHomeData;
